import React from 'react';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { Loading } from '../../../../../CommonComponents/OPL/Loading/Loading';

export const LoadingWhatIf = () => (
  <Box flexGrow={1} display="flex" alignItems="center" justifyContent="center" height="100%">
    <Loading text="Loading..." />
  </Box>
);
